import { Col, Row } from "react-bootstrap";
import AdminLayout from "./layout/AdminLayout";
import ReportList from "../components/admin/report/ReportList";
const Report = () => {
  return (
    <AdminLayout>
      <Row>
        {/* <h1 className="title mb-4">Dashboard</h1> */}
        <Col className="container mb-4">
          <ReportList />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default Report;
